module.exports = __webpack_public_path__ + "img/img18.0be99f8c.jpeg";